@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(638_190_962)
internal val Res.string.exp_content_segni_vari_5: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_5", "exp_content_segni_vari_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124997, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123233, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124834, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118697, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115685, 112),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_segni_vari_6: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_6", "exp_content_segni_vari_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125122, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123342, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124951, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118806, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115798, 40),
      ))
    }

@delegate:ResourceContentHash(-556_079_165)
internal val Res.string.exp_content_segni_vari_7: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_7", "exp_content_segni_vari_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125163, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123387, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124996, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118847, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115839, 104),
      ))
    }

@delegate:ResourceContentHash(-506_834_435)
internal val Res.string.exp_content_segue_il_nome_di_nascita_profano_del_faraone: StringResource by
    lazy {
      StringResource("string:exp_content_segue_il_nome_di_nascita_profano_del_faraone", "exp_content_segue_il_nome_di_nascita_profano_del_faraone", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125300, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123520, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125129, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118952, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115944, 132),
      ))
    }

@delegate:ResourceContentHash(-939_625_841)
internal val Res.string.exp_content_seven_ending_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_alyn_1", "exp_content_seven_ending_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125437, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123665, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125274, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119093, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116077, 79),
      ))
    }

@delegate:ResourceContentHash(1_780_903_947)
internal val Res.string.exp_content_seven_ending_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_alyn_2", "exp_content_seven_ending_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125521, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123749, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125362, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119173, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116157, 83),
      ))
    }

@delegate:ResourceContentHash(2_046_600_475)
internal val Res.string.exp_content_seven_ending_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_nilo_1", "exp_content_seven_ending_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125617, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123825, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125450, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119253, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116241, 119),
      ))
    }

@delegate:ResourceContentHash(-630_327_427)
internal val Res.string.exp_content_seven_ending_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_nilo_2", "exp_content_seven_ending_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125757, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123953, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125562, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119377, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116361, 75),
      ))
    }

@delegate:ResourceContentHash(902_820_662)
internal val Res.string.exp_content_seven_ending_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_nilo_3", "exp_content_seven_ending_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125841, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124025, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125630, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119445, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116437, 99),
      ))
    }

@delegate:ResourceContentHash(-1_544_016_259)
internal val Res.string.exp_content_seven_ending_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_seven_ending_nilo_4", "exp_content_seven_ending_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125949, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124125, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125754, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119545, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116537, 95),
      ))
    }

@delegate:ResourceContentHash(246_989_465)
internal val Res.string.exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell: StringResource by
    lazy {
      StringResource("string:exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell", "exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126077, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124237, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 125878, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119645, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116633, 169),
      ))
    }

@delegate:ResourceContentHash(2_087_053_431)
internal val Res.string.exp_content_si_scrive_aq_si_legge_aq_e_significa_entrare: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_aq_si_legge_aq_e_significa_entrare", "exp_content_si_scrive_aq_si_legge_aq_e_significa_entrare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126271, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124407, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126060, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119815, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116803, 140),
      ))
    }

@delegate:ResourceContentHash(-2_089_436_245)
internal val Res.string.exp_content_si_scrive_dd_si_legge_djed_e_significa_dire: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_dd_si_legge_djed_e_significa_dire", "exp_content_si_scrive_dd_si_legge_djed_e_significa_dire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126424, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124540, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126205, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 119948, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116944, 131),
      ))
    }

@delegate:ResourceContentHash(441_652_213)
internal val Res.string.exp_content_si_scrive_dt_si_legge_djet_e_significa_eterni: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_dt_si_legge_djet_e_significa_eterni", "exp_content_si_scrive_dt_si_legge_djet_e_significa_eterni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126572, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124676, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126341, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120080, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117076, 137),
      ))
    }

@delegate:ResourceContentHash(-1_876_792_045)
internal val Res.string.exp_content_si_scrive_dwat_si_legge_duat_e_significa_duat: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_dwat_si_legge_duat_e_significa_duat", "exp_content_si_scrive_dwat_si_legge_duat_e_significa_duat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126726, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124818, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126487, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120222, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117214, 149),
      ))
    }

@delegate:ResourceContentHash(-1_659_287_230)
internal val Res.string.exp_content_si_scrive_hwt_si_legge_hut_e_significa_tempio: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_hwt_si_legge_hut_e_significa_tempio", "exp_content_si_scrive_hwt_si_legge_hut_e_significa_tempio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 126888, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 124972, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126641, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120376, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117364, 145),
      ))
    }

@delegate:ResourceContentHash(-1_692_925_782)
internal val Res.string.exp_content_si_scrive_ir_si_legge_ir_e_significa_fare: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_ir_si_legge_ir_e_significa_fare", "exp_content_si_scrive_ir_si_legge_ir_e_significa_fare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127046, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125126, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126795, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120530, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117510, 125),
      ))
    }

@delegate:ResourceContentHash(763_195_343)
internal val Res.string.exp_content_si_scrive_iwnw_si_legge_iunu_e_significa_citt: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_iwnw_si_legge_iunu_e_significa_citt", "exp_content_si_scrive_iwnw_si_legge_iunu_e_significa_citt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127184, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125256, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 126925, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120656, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117636, 157),
      ))
    }

@delegate:ResourceContentHash(-767_661_718)
internal val Res.string.exp_content_si_scrive_mri_si_legge_meri_e_significa_amare: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_mri_si_legge_meri_e_significa_amare", "exp_content_si_scrive_mri_si_legge_meri_e_significa_amare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127358, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125422, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127091, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120818, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117794, 141),
      ))
    }

@delegate:ResourceContentHash(1_219_876_534)
internal val Res.string.exp_content_si_scrive_pr_si_legge_per_e_significa_casa_us: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_pr_si_legge_per_e_significa_casa_us", "exp_content_si_scrive_pr_si_legge_per_e_significa_casa_us", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127508, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125556, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127241, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 120952, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117936, 141),
      ))
    }

@delegate:ResourceContentHash(1_154_676_819)
internal val Res.string.exp_content_si_scrive_pri_si_legge_peri_e_significa_uscir: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_pri_si_legge_peri_e_significa_uscir", "exp_content_si_scrive_pri_si_legge_peri_e_significa_uscir", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127670, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125698, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127391, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121094, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118078, 145),
      ))
    }

@delegate:ResourceContentHash(-543_418_440)
internal val Res.string.exp_content_si_scrive_rdi_si_legge_redi_e_significa_dare: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_rdi_si_legge_redi_e_significa_dare", "exp_content_si_scrive_rdi_si_legge_redi_e_significa_dare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127828, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125836, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127541, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121232, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118224, 132),
      ))
    }

@delegate:ResourceContentHash(1_824_152_040)
internal val Res.string.exp_content_si_scrive_sdm_si_legge_sedjem_e_significa_asc: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_sdm_si_legge_sedjem_e_significa_asc", "exp_content_si_scrive_sdm_si_legge_sedjem_e_significa_asc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 127977, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 125969, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127678, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121365, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118357, 145),
      ))
    }

@delegate:ResourceContentHash(315_460_389)
internal val Res.string.exp_content_si_scrive_swr_si_legge_sewer_e_significa_bere: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_swr_si_legge_sewer_e_significa_bere", "exp_content_si_scrive_swr_si_legge_sewer_e_significa_bere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128131, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126115, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127824, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121511, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118503, 137),
      ))
    }

@delegate:ResourceContentHash(-1_977_787_961)
internal val Res.string.exp_content_si_scrive_ta_si_legge_ta_e_significa_terra: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_ta_si_legge_ta_e_significa_terra", "exp_content_si_scrive_ta_si_legge_ta_e_significa_terra", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128285, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126253, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127962, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121645, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118641, 126),
      ))
    }

@delegate:ResourceContentHash(816_411_378)
internal val Res.string.exp_content_si_scrive_wn_si_legge_wen_e_significa_esister: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_wn_si_legge_wen_e_significa_esister", "exp_content_si_scrive_wn_si_legge_wen_e_significa_esister", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128424, 161),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126384, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128093, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121772, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118768, 141),
      ))
    }

@delegate:ResourceContentHash(-767_479_753)
internal val Res.string.exp_content_si_scrive_wnm_si_legge_wenem_e_significa_mang: StringResource by
    lazy {
      StringResource("string:exp_content_si_scrive_wnm_si_legge_wenem_e_significa_mang", "exp_content_si_scrive_wnm_si_legge_wenem_e_significa_mang", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128586, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126530, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128243, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 121922, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118910, 133),
      ))
    }

@delegate:ResourceContentHash(799_733_647)
internal val Res.string.exp_content_sicuramente_avevano_vocali_diverse_messe_qua_: StringResource by
    lazy {
      StringResource("string:exp_content_sicuramente_avevano_vocali_diverse_messe_qua_", "exp_content_sicuramente_avevano_vocali_diverse_messe_qua_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128736, 253),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126668, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128385, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122064, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119044, 209),
      ))
    }

@delegate:ResourceContentHash(-2_012_186_692)
internal val Res.string.exp_content_significato_dei_nomi_1: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_1", "exp_content_significato_dei_nomi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 128990, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126882, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128619, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122258, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119254, 90),
      ))
    }

@delegate:ResourceContentHash(-1_213_746_528)
internal val Res.string.exp_content_significato_dei_nomi_2: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_2", "exp_content_significato_dei_nomi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129085, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126997, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128714, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122353, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119345, 126),
      ))
    }

@delegate:ResourceContentHash(1_132_547_405)
internal val Res.string.exp_content_significato_dei_nomi_3: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_3", "exp_content_significato_dei_nomi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129232, 166),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127144, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 128865, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122488, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119472, 158),
      ))
    }

@delegate:ResourceContentHash(-1_307_500_186)
internal val Res.string.exp_content_significato_dei_nomi_4: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_4", "exp_content_significato_dei_nomi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129399, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127311, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129032, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122647, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119631, 106),
      ))
    }

@delegate:ResourceContentHash(1_500_297_749)
internal val Res.string.exp_content_significato_dei_nomi_5: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_5", "exp_content_significato_dei_nomi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129518, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127430, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129163, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122762, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119738, 78),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_significato_dei_nomi_6: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_6", "exp_content_significato_dei_nomi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129597, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127517, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129262, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122841, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119817, 50),
      ))
    }

@delegate:ResourceContentHash(-1_684_124_827)
internal val Res.string.exp_content_significato_dei_nomi_7: StringResource by lazy {
      StringResource("string:exp_content_significato_dei_nomi_7", "exp_content_significato_dei_nomi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129648, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127572, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129317, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 122892, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119868, 110),
      ))
    }

@delegate:ResourceContentHash(1_972_126_595)
internal val Res.string.exp_content_soggetto_esplicito_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_alyn_1", "exp_content_soggetto_esplicito_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129763, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127699, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129436, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123003, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119979, 145),
      ))
    }

@delegate:ResourceContentHash(-1_958_925_187)
internal val Res.string.exp_content_soggetto_esplicito_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_alyn_2", "exp_content_soggetto_esplicito_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 129941, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127865, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129582, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123165, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120125, 73),
      ))
    }

@delegate:ResourceContentHash(496_073_045)
internal val Res.string.exp_content_soggetto_esplicito_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_alyn_3", "exp_content_soggetto_esplicito_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130015, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 127939, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129664, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123243, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120199, 89),
      ))
    }

@delegate:ResourceContentHash(-1_962_919_363)
internal val Res.string.exp_content_soggetto_esplicito_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_alyn_4", "exp_content_soggetto_esplicito_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130109, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128025, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129758, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123329, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120289, 97),
      ))
    }

@delegate:ResourceContentHash(487_350_344)
internal val Res.string.exp_content_soggetto_esplicito_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_nilo_1", "exp_content_soggetto_esplicito_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130219, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128127, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129860, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123423, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120387, 121),
      ))
    }

@delegate:ResourceContentHash(1_475_541_053)
internal val Res.string.exp_content_soggetto_esplicito_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_nilo_2", "exp_content_soggetto_esplicito_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130341, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128245, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 129986, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123537, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120509, 85),
      ))
    }

@delegate:ResourceContentHash(-1_993_910_680)
internal val Res.string.exp_content_soggetto_esplicito_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_soggetto_esplicito_nilo_3", "exp_content_soggetto_esplicito_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130431, 229),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128331, 217),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130076, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123627, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120595, 205),
      ))
    }

@delegate:ResourceContentHash(-1_954_444_660)
internal val Res.string.exp_content_speriamo_di_incontrare_presto_il_prossimo_ger: StringResource by
    lazy {
      StringResource("string:exp_content_speriamo_di_incontrare_presto_il_prossimo_ger", "exp_content_speriamo_di_incontrare_presto_il_prossimo_ger", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130661, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128549, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130310, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123821, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120801, 149),
      ))
    }

@delegate:ResourceContentHash(698_100_446)
internal val Res.string.exp_content_sta_succedendo_una_cosa_strana: StringResource by lazy {
      StringResource("string:exp_content_sta_succedendo_una_cosa_strana", "exp_content_sta_succedendo_una_cosa_strana", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130827, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128711, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130484, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 123979, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120951, 94),
      ))
    }

@delegate:ResourceContentHash(-678_162_219)
internal val Res.string.exp_content_struttura_n_nome_con_articolo_nome_in_apposizione:
    StringResource by lazy {
      StringResource("string:exp_content_struttura_n_nome_con_articolo_nome_in_apposizione", "exp_content_struttura_n_nome_con_articolo_nome_in_apposizione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 130914, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128802, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130579, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124074, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121046, 105),
      ))
    }

@delegate:ResourceContentHash(-315_946_704)
internal val Res.string.exp_content_studiamo_hiero_vari_1: StringResource by lazy {
      StringResource("string:exp_content_studiamo_hiero_vari_1", "exp_content_studiamo_hiero_vari_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131020, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 128908, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130689, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124180, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121152, 129),
      ))
    }

@delegate:ResourceContentHash(-315_946_704)
internal val Res.string.exp_content_studiamo_hiero_vari_2: StringResource by lazy {
      StringResource("string:exp_content_studiamo_hiero_vari_2", "exp_content_studiamo_hiero_vari_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131166, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129062, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130843, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124314, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121282, 129),
      ))
    }

@delegate:ResourceContentHash(-1_292_483_519)
internal val Res.string.exp_content_studiamo_hiero_vso_1: StringResource by lazy {
      StringResource("string:exp_content_studiamo_hiero_vso_1", "exp_content_studiamo_hiero_vso_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131312, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129216, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 130997, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124448, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121412, 156),
      ))
    }

@delegate:ResourceContentHash(882_192_694)
internal val Res.string.exp_content_studiamo_hiero_vso_2: StringResource by lazy {
      StringResource("string:exp_content_studiamo_hiero_vso_2", "exp_content_studiamo_hiero_vso_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131485, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129381, 172),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 131162, 168),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124593, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121569, 156),
      ))
    }

@delegate:ResourceContentHash(47_780_597)
internal val Res.string.exp_content_studiamo_hiero_vso_3: StringResource by lazy {
      StringResource("string:exp_content_studiamo_hiero_vso_3", "exp_content_studiamo_hiero_vso_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131666, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129554, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 131331, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124742, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121726, 152),
      ))
    }

@delegate:ResourceContentHash(1_360_978_711)
internal val Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono: StringResource by
    lazy {
      StringResource("string:exp_content_studiamo_i_singoli_geroglifici_che_compongono", "exp_content_studiamo_i_singoli_geroglifici_che_compongono", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132403, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130311, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132056, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125419, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122403, 161),
      ))
    }

@delegate:ResourceContentHash(-2_046_945_972)
internal val Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_2: StringResource
    by lazy {
      StringResource("string:exp_content_studiamo_i_singoli_geroglifici_che_compongono_2", "exp_content_studiamo_i_singoli_geroglifici_che_compongono_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 131835, 167),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129719, 183),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 131492, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 124887, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121879, 159),
      ))
    }

@delegate:ResourceContentHash(1_801_471_335)
internal val Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_3: StringResource
    by lazy {
      StringResource("string:exp_content_studiamo_i_singoli_geroglifici_che_compongono_3", "exp_content_studiamo_i_singoli_geroglifici_che_compongono_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132003, 187),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 129903, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 131668, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125051, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122039, 163),
      ))
    }

@delegate:ResourceContentHash(-597_623_741)
internal val Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_4: StringResource
    by lazy {
      StringResource("string:exp_content_studiamo_i_singoli_geroglifici_che_compongono_4", "exp_content_studiamo_i_singoli_geroglifici_che_compongono_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132191, 211),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130079, 231),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 131840, 215),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125207, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122203, 199),
      ))
    }

@delegate:ResourceContentHash(619_956_722)
internal val Res.string.exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_: StringResource by
    lazy {
      StringResource("string:exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_", "exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132581, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130489, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132238, 205),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125573, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122565, 185),
      ))
    }

@delegate:ResourceContentHash(-980_000_596)
internal val Res.string.exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia: StringResource by
    lazy {
      StringResource("string:exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia", "exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132775, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130687, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132444, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125759, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122751, 141),
      ))
    }

@delegate:ResourceContentHash(-1_944_457_583)
internal val Res.string.exp_content_torniamo_alla_grammatica_1: StringResource by lazy {
      StringResource("string:exp_content_torniamo_alla_grammatica_1", "exp_content_torniamo_alla_grammatica_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 132929, 190),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 130841, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132602, 202),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 125901, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122893, 162),
      ))
    }

@delegate:ResourceContentHash(182_182)
internal val Res.string.exp_content_torniamo_alla_grammatica_2: StringResource by lazy {
      StringResource("string:exp_content_torniamo_alla_grammatica_2", "exp_content_torniamo_alla_grammatica_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133120, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131008, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132805, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126060, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123056, 130),
      ))
    }

@delegate:ResourceContentHash(-32_618_301)
internal val Res.string.exp_content_torniamo_alla_grammatica_3: StringResource by lazy {
      StringResource("string:exp_content_torniamo_alla_grammatica_3", "exp_content_torniamo_alla_grammatica_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133275, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131151, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 132944, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126203, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123187, 158),
      ))
    }

@delegate:ResourceContentHash(-1_214_780_336)
internal val Res.string.exp_content_traduciamo_i_nomi_1: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_1", "exp_content_traduciamo_i_nomi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134075, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131943, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133736, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126951, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123955, 63),
      ))
    }

@delegate:ResourceContentHash(-2_146_799_443)
internal val Res.string.exp_content_traduciamo_i_nomi_10: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_10", "exp_content_traduciamo_i_nomi_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133438, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131310, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133111, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126362, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123346, 124),
      ))
    }

@delegate:ResourceContentHash(-141_503_204)
internal val Res.string.exp_content_traduciamo_i_nomi_11: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_11", "exp_content_traduciamo_i_nomi_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133563, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131431, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133240, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126475, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123471, 116),
      ))
    }

@delegate:ResourceContentHash(99_103_022)
internal val Res.string.exp_content_traduciamo_i_nomi_12: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_12", "exp_content_traduciamo_i_nomi_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133680, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131556, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133357, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126588, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123588, 112),
      ))
    }

@delegate:ResourceContentHash(-881_856_376)
internal val Res.string.exp_content_traduciamo_i_nomi_13: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_13", "exp_content_traduciamo_i_nomi_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133801, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131685, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133478, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126709, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123701, 148),
      ))
    }

@delegate:ResourceContentHash(-75_474_687)
internal val Res.string.exp_content_traduciamo_i_nomi_14: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_14", "exp_content_traduciamo_i_nomi_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 133974, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131838, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133643, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 126854, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123850, 104),
      ))
    }

@delegate:ResourceContentHash(-793_127_498)
internal val Res.string.exp_content_traduciamo_i_nomi_2: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_2", "exp_content_traduciamo_i_nomi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134151, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132015, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133804, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127015, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124019, 107),
      ))
    }

@delegate:ResourceContentHash(2_074_481_643)
internal val Res.string.exp_content_traduciamo_i_nomi_3: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_3", "exp_content_traduciamo_i_nomi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134271, 163),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132143, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 133924, 167),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127131, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124127, 143),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_traduciamo_i_nomi_4: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_4", "exp_content_traduciamo_i_nomi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134435, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132299, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134092, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127275, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124271, 43),
      ))
    }

@delegate:ResourceContentHash(1_899_219_242)
internal val Res.string.exp_content_traduciamo_i_nomi_5: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_5", "exp_content_traduciamo_i_nomi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134479, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132343, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134136, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127319, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124315, 79),
      ))
    }

@delegate:ResourceContentHash(-346_424_171)
internal val Res.string.exp_content_traduciamo_i_nomi_6: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_6", "exp_content_traduciamo_i_nomi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134563, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132435, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134220, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127411, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124395, 67),
      ))
    }

@delegate:ResourceContentHash(-709_246_789)
internal val Res.string.exp_content_traduciamo_i_nomi_7: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_7", "exp_content_traduciamo_i_nomi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134651, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132507, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134312, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127479, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124463, 67),
      ))
    }

@delegate:ResourceContentHash(2_005_985_790)
internal val Res.string.exp_content_traduciamo_i_nomi_8: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_8", "exp_content_traduciamo_i_nomi_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134719, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132579, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134380, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127547, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124531, 47),
      ))
    }

@delegate:ResourceContentHash(1_913_452_975)
internal val Res.string.exp_content_traduciamo_i_nomi_9: StringResource by lazy {
      StringResource("string:exp_content_traduciamo_i_nomi_9", "exp_content_traduciamo_i_nomi_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134767, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132631, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134428, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127595, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124579, 119),
      ))
    }

@delegate:ResourceContentHash(-1_385_606_457)
internal val Res.string.exp_content_transliteration_reading_dialog_1: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_1", "exp_content_transliteration_reading_dialog_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134871, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132723, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134548, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127707, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124699, 60),
      ))
    }

@delegate:ResourceContentHash(-638_208_348)
internal val Res.string.exp_content_transliteration_reading_dialog_2: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_2", "exp_content_transliteration_reading_dialog_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 134932, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132788, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134613, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127768, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124760, 140),
      ))
    }

@delegate:ResourceContentHash(334_910_429)
internal val Res.string.exp_content_transliteration_reading_dialog_3: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_3", "exp_content_transliteration_reading_dialog_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135069, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 132941, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134754, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127897, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124901, 72),
      ))
    }

@delegate:ResourceContentHash(-39_643_551)
internal val Res.string.exp_content_transliteration_reading_dialog_4: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_4", "exp_content_transliteration_reading_dialog_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135142, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133018, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134823, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 127974, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124974, 56),
      ))
    }

@delegate:ResourceContentHash(1_375_445_643)
internal val Res.string.exp_content_transliteration_reading_dialog_5: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_5", "exp_content_transliteration_reading_dialog_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135199, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133075, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 134880, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128031, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125031, 136),
      ))
    }

@delegate:ResourceContentHash(792_455_642)
internal val Res.string.exp_content_transliteration_reading_dialog_6: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_6", "exp_content_transliteration_reading_dialog_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135352, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133216, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135017, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128164, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125168, 60),
      ))
    }

@delegate:ResourceContentHash(-1_395_938_428)
internal val Res.string.exp_content_transliteration_reading_dialog_7: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_7", "exp_content_transliteration_reading_dialog_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135413, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133277, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135078, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128225, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125229, 148),
      ))
    }

@delegate:ResourceContentHash(1_732_858_119)
internal val Res.string.exp_content_transliteration_reading_dialog_8: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_dialog_8", "exp_content_transliteration_reading_dialog_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135598, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133438, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135259, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128374, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125378, 64),
      ))
    }

@delegate:ResourceContentHash(336_585_386)
internal val Res.string.exp_content_transliteration_reading_point_1: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_1", "exp_content_transliteration_reading_point_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135663, 227),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133503, 187),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135324, 227),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128439, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125443, 195),
      ))
    }

@delegate:ResourceContentHash(468_554_367)
internal val Res.string.exp_content_transliteration_reading_point_2: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_2", "exp_content_transliteration_reading_point_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 135891, 211),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133691, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135552, 211),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128619, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125639, 163),
      ))
    }

@delegate:ResourceContentHash(-1_072_477_648)
internal val Res.string.exp_content_transliteration_reading_point_3: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_3", "exp_content_transliteration_reading_point_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136103, 179),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133855, 219),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135764, 179),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128787, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125803, 175),
      ))
    }

@delegate:ResourceContentHash(304_986_047)
internal val Res.string.exp_content_transliteration_reading_point_4: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_4", "exp_content_transliteration_reading_point_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136283, 251),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134075, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135944, 191),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 128979, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125979, 159),
      ))
    }

@delegate:ResourceContentHash(-1_548_574_723)
internal val Res.string.exp_content_transliteration_reading_point_5: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_5", "exp_content_transliteration_reading_point_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136535, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134239, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136136, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129147, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126139, 131),
      ))
    }

@delegate:ResourceContentHash(1_827_767_565)
internal val Res.string.exp_content_transliteration_reading_point_6: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_6", "exp_content_transliteration_reading_point_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136667, 159),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134379, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136284, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129275, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126271, 135),
      ))
    }

@delegate:ResourceContentHash(225_893_136)
internal val Res.string.exp_content_transliteration_reading_point_7: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_7", "exp_content_transliteration_reading_point_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136827, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134515, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136432, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129407, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126407, 91),
      ))
    }

@delegate:ResourceContentHash(1_707_976_022)
internal val Res.string.exp_content_transliteration_reading_point_8: StringResource by lazy {
      StringResource("string:exp_content_transliteration_reading_point_8", "exp_content_transliteration_reading_point_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 136931, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134603, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136520, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129491, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126499, 75),
      ))
    }

@delegate:ResourceContentHash(1_296_781_700)
internal val Res.string.exp_content_tutto_insieme_ora_1: StringResource by lazy {
      StringResource("string:exp_content_tutto_insieme_ora_1", "exp_content_tutto_insieme_ora_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137007, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134687, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136596, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129567, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126575, 119),
      ))
    }

@delegate:ResourceContentHash(-323_755_955)
internal val Res.string.exp_content_tutto_insieme_ora_2: StringResource by lazy {
      StringResource("string:exp_content_tutto_insieme_ora_2", "exp_content_tutto_insieme_ora_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137131, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134827, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136732, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129695, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126695, 59),
      ))
    }

@delegate:ResourceContentHash(-2_090_530_699)
internal val Res.string.exp_content_tutto_insieme_ora_3: StringResource by lazy {
      StringResource("string:exp_content_tutto_insieme_ora_3", "exp_content_tutto_insieme_ora_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137191, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134891, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136796, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129755, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126755, 79),
      ))
    }

@delegate:ResourceContentHash(-1_587_147_611)
internal val Res.string.exp_content_twt_ankh_imn_tutankhamon: StringResource by lazy {
      StringResource("string:exp_content_twt_ankh_imn_tutankhamon", "exp_content_twt_ankh_imn_tutankhamon", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137295, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 134979, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136884, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129839, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126835, 112),
      ))
    }

@delegate:ResourceContentHash(1_448_542_230)
internal val Res.string.exp_content_un_attimo_1: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_1", "exp_content_un_attimo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137694, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135346, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137271, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130206, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127194, 103),
      ))
    }

@delegate:ResourceContentHash(1_308_556_654)
internal val Res.string.exp_content_un_attimo_10: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_10", "exp_content_un_attimo_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137416, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135096, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137005, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 129956, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 126948, 132),
      ))
    }

@delegate:ResourceContentHash(489_995_247)
internal val Res.string.exp_content_un_attimo_11: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_11", "exp_content_un_attimo_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137565, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135229, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137146, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130093, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127081, 112),
      ))
    }

@delegate:ResourceContentHash(-1_324_379_064)
internal val Res.string.exp_content_un_attimo_2: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_2", "exp_content_un_attimo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137806, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135446, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137387, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130318, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127298, 107),
      ))
    }

@delegate:ResourceContentHash(1_862_576_254)
internal val Res.string.exp_content_un_attimo_3: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_3", "exp_content_un_attimo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 137930, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135550, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137511, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130434, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127406, 79),
      ))
    }

@delegate:ResourceContentHash(2_033_133_737)
internal val Res.string.exp_content_un_attimo_4: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_4", "exp_content_un_attimo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138018, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135642, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137615, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130514, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127486, 95),
      ))
    }

@delegate:ResourceContentHash(-362_136_230)
internal val Res.string.exp_content_un_attimo_5: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_5", "exp_content_un_attimo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138122, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135742, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137727, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130610, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127582, 127),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString11Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_segni_vari_5", Res.string.exp_content_segni_vari_5)
  map.put("exp_content_segni_vari_6", Res.string.exp_content_segni_vari_6)
  map.put("exp_content_segni_vari_7", Res.string.exp_content_segni_vari_7)
  map.put("exp_content_segue_il_nome_di_nascita_profano_del_faraone", Res.string.exp_content_segue_il_nome_di_nascita_profano_del_faraone)
  map.put("exp_content_seven_ending_alyn_1", Res.string.exp_content_seven_ending_alyn_1)
  map.put("exp_content_seven_ending_alyn_2", Res.string.exp_content_seven_ending_alyn_2)
  map.put("exp_content_seven_ending_nilo_1", Res.string.exp_content_seven_ending_nilo_1)
  map.put("exp_content_seven_ending_nilo_2", Res.string.exp_content_seven_ending_nilo_2)
  map.put("exp_content_seven_ending_nilo_3", Res.string.exp_content_seven_ending_nilo_3)
  map.put("exp_content_seven_ending_nilo_4", Res.string.exp_content_seven_ending_nilo_4)
  map.put("exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell", Res.string.exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell)
  map.put("exp_content_si_scrive_aq_si_legge_aq_e_significa_entrare", Res.string.exp_content_si_scrive_aq_si_legge_aq_e_significa_entrare)
  map.put("exp_content_si_scrive_dd_si_legge_djed_e_significa_dire", Res.string.exp_content_si_scrive_dd_si_legge_djed_e_significa_dire)
  map.put("exp_content_si_scrive_dt_si_legge_djet_e_significa_eterni", Res.string.exp_content_si_scrive_dt_si_legge_djet_e_significa_eterni)
  map.put("exp_content_si_scrive_dwat_si_legge_duat_e_significa_duat", Res.string.exp_content_si_scrive_dwat_si_legge_duat_e_significa_duat)
  map.put("exp_content_si_scrive_hwt_si_legge_hut_e_significa_tempio", Res.string.exp_content_si_scrive_hwt_si_legge_hut_e_significa_tempio)
  map.put("exp_content_si_scrive_ir_si_legge_ir_e_significa_fare", Res.string.exp_content_si_scrive_ir_si_legge_ir_e_significa_fare)
  map.put("exp_content_si_scrive_iwnw_si_legge_iunu_e_significa_citt", Res.string.exp_content_si_scrive_iwnw_si_legge_iunu_e_significa_citt)
  map.put("exp_content_si_scrive_mri_si_legge_meri_e_significa_amare", Res.string.exp_content_si_scrive_mri_si_legge_meri_e_significa_amare)
  map.put("exp_content_si_scrive_pr_si_legge_per_e_significa_casa_us", Res.string.exp_content_si_scrive_pr_si_legge_per_e_significa_casa_us)
  map.put("exp_content_si_scrive_pri_si_legge_peri_e_significa_uscir", Res.string.exp_content_si_scrive_pri_si_legge_peri_e_significa_uscir)
  map.put("exp_content_si_scrive_rdi_si_legge_redi_e_significa_dare", Res.string.exp_content_si_scrive_rdi_si_legge_redi_e_significa_dare)
  map.put("exp_content_si_scrive_sdm_si_legge_sedjem_e_significa_asc", Res.string.exp_content_si_scrive_sdm_si_legge_sedjem_e_significa_asc)
  map.put("exp_content_si_scrive_swr_si_legge_sewer_e_significa_bere", Res.string.exp_content_si_scrive_swr_si_legge_sewer_e_significa_bere)
  map.put("exp_content_si_scrive_ta_si_legge_ta_e_significa_terra", Res.string.exp_content_si_scrive_ta_si_legge_ta_e_significa_terra)
  map.put("exp_content_si_scrive_wn_si_legge_wen_e_significa_esister", Res.string.exp_content_si_scrive_wn_si_legge_wen_e_significa_esister)
  map.put("exp_content_si_scrive_wnm_si_legge_wenem_e_significa_mang", Res.string.exp_content_si_scrive_wnm_si_legge_wenem_e_significa_mang)
  map.put("exp_content_sicuramente_avevano_vocali_diverse_messe_qua_", Res.string.exp_content_sicuramente_avevano_vocali_diverse_messe_qua_)
  map.put("exp_content_significato_dei_nomi_1", Res.string.exp_content_significato_dei_nomi_1)
  map.put("exp_content_significato_dei_nomi_2", Res.string.exp_content_significato_dei_nomi_2)
  map.put("exp_content_significato_dei_nomi_3", Res.string.exp_content_significato_dei_nomi_3)
  map.put("exp_content_significato_dei_nomi_4", Res.string.exp_content_significato_dei_nomi_4)
  map.put("exp_content_significato_dei_nomi_5", Res.string.exp_content_significato_dei_nomi_5)
  map.put("exp_content_significato_dei_nomi_6", Res.string.exp_content_significato_dei_nomi_6)
  map.put("exp_content_significato_dei_nomi_7", Res.string.exp_content_significato_dei_nomi_7)
  map.put("exp_content_soggetto_esplicito_alyn_1", Res.string.exp_content_soggetto_esplicito_alyn_1)
  map.put("exp_content_soggetto_esplicito_alyn_2", Res.string.exp_content_soggetto_esplicito_alyn_2)
  map.put("exp_content_soggetto_esplicito_alyn_3", Res.string.exp_content_soggetto_esplicito_alyn_3)
  map.put("exp_content_soggetto_esplicito_alyn_4", Res.string.exp_content_soggetto_esplicito_alyn_4)
  map.put("exp_content_soggetto_esplicito_nilo_1", Res.string.exp_content_soggetto_esplicito_nilo_1)
  map.put("exp_content_soggetto_esplicito_nilo_2", Res.string.exp_content_soggetto_esplicito_nilo_2)
  map.put("exp_content_soggetto_esplicito_nilo_3", Res.string.exp_content_soggetto_esplicito_nilo_3)
  map.put("exp_content_speriamo_di_incontrare_presto_il_prossimo_ger", Res.string.exp_content_speriamo_di_incontrare_presto_il_prossimo_ger)
  map.put("exp_content_sta_succedendo_una_cosa_strana", Res.string.exp_content_sta_succedendo_una_cosa_strana)
  map.put("exp_content_struttura_n_nome_con_articolo_nome_in_apposizione", Res.string.exp_content_struttura_n_nome_con_articolo_nome_in_apposizione)
  map.put("exp_content_studiamo_hiero_vari_1", Res.string.exp_content_studiamo_hiero_vari_1)
  map.put("exp_content_studiamo_hiero_vari_2", Res.string.exp_content_studiamo_hiero_vari_2)
  map.put("exp_content_studiamo_hiero_vso_1", Res.string.exp_content_studiamo_hiero_vso_1)
  map.put("exp_content_studiamo_hiero_vso_2", Res.string.exp_content_studiamo_hiero_vso_2)
  map.put("exp_content_studiamo_hiero_vso_3", Res.string.exp_content_studiamo_hiero_vso_3)
  map.put("exp_content_studiamo_i_singoli_geroglifici_che_compongono", Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono)
  map.put("exp_content_studiamo_i_singoli_geroglifici_che_compongono_2", Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_2)
  map.put("exp_content_studiamo_i_singoli_geroglifici_che_compongono_3", Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_3)
  map.put("exp_content_studiamo_i_singoli_geroglifici_che_compongono_4", Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono_4)
  map.put("exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_", Res.string.exp_content_ti_ricordi_la_misteriosa_iscrizione_luminosa_)
  map.put("exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia", Res.string.exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia)
  map.put("exp_content_torniamo_alla_grammatica_1", Res.string.exp_content_torniamo_alla_grammatica_1)
  map.put("exp_content_torniamo_alla_grammatica_2", Res.string.exp_content_torniamo_alla_grammatica_2)
  map.put("exp_content_torniamo_alla_grammatica_3", Res.string.exp_content_torniamo_alla_grammatica_3)
  map.put("exp_content_traduciamo_i_nomi_1", Res.string.exp_content_traduciamo_i_nomi_1)
  map.put("exp_content_traduciamo_i_nomi_10", Res.string.exp_content_traduciamo_i_nomi_10)
  map.put("exp_content_traduciamo_i_nomi_11", Res.string.exp_content_traduciamo_i_nomi_11)
  map.put("exp_content_traduciamo_i_nomi_12", Res.string.exp_content_traduciamo_i_nomi_12)
  map.put("exp_content_traduciamo_i_nomi_13", Res.string.exp_content_traduciamo_i_nomi_13)
  map.put("exp_content_traduciamo_i_nomi_14", Res.string.exp_content_traduciamo_i_nomi_14)
  map.put("exp_content_traduciamo_i_nomi_2", Res.string.exp_content_traduciamo_i_nomi_2)
  map.put("exp_content_traduciamo_i_nomi_3", Res.string.exp_content_traduciamo_i_nomi_3)
  map.put("exp_content_traduciamo_i_nomi_4", Res.string.exp_content_traduciamo_i_nomi_4)
  map.put("exp_content_traduciamo_i_nomi_5", Res.string.exp_content_traduciamo_i_nomi_5)
  map.put("exp_content_traduciamo_i_nomi_6", Res.string.exp_content_traduciamo_i_nomi_6)
  map.put("exp_content_traduciamo_i_nomi_7", Res.string.exp_content_traduciamo_i_nomi_7)
  map.put("exp_content_traduciamo_i_nomi_8", Res.string.exp_content_traduciamo_i_nomi_8)
  map.put("exp_content_traduciamo_i_nomi_9", Res.string.exp_content_traduciamo_i_nomi_9)
  map.put("exp_content_transliteration_reading_dialog_1", Res.string.exp_content_transliteration_reading_dialog_1)
  map.put("exp_content_transliteration_reading_dialog_2", Res.string.exp_content_transliteration_reading_dialog_2)
  map.put("exp_content_transliteration_reading_dialog_3", Res.string.exp_content_transliteration_reading_dialog_3)
  map.put("exp_content_transliteration_reading_dialog_4", Res.string.exp_content_transliteration_reading_dialog_4)
  map.put("exp_content_transliteration_reading_dialog_5", Res.string.exp_content_transliteration_reading_dialog_5)
  map.put("exp_content_transliteration_reading_dialog_6", Res.string.exp_content_transliteration_reading_dialog_6)
  map.put("exp_content_transliteration_reading_dialog_7", Res.string.exp_content_transliteration_reading_dialog_7)
  map.put("exp_content_transliteration_reading_dialog_8", Res.string.exp_content_transliteration_reading_dialog_8)
  map.put("exp_content_transliteration_reading_point_1", Res.string.exp_content_transliteration_reading_point_1)
  map.put("exp_content_transliteration_reading_point_2", Res.string.exp_content_transliteration_reading_point_2)
  map.put("exp_content_transliteration_reading_point_3", Res.string.exp_content_transliteration_reading_point_3)
  map.put("exp_content_transliteration_reading_point_4", Res.string.exp_content_transliteration_reading_point_4)
  map.put("exp_content_transliteration_reading_point_5", Res.string.exp_content_transliteration_reading_point_5)
  map.put("exp_content_transliteration_reading_point_6", Res.string.exp_content_transliteration_reading_point_6)
  map.put("exp_content_transliteration_reading_point_7", Res.string.exp_content_transliteration_reading_point_7)
  map.put("exp_content_transliteration_reading_point_8", Res.string.exp_content_transliteration_reading_point_8)
  map.put("exp_content_tutto_insieme_ora_1", Res.string.exp_content_tutto_insieme_ora_1)
  map.put("exp_content_tutto_insieme_ora_2", Res.string.exp_content_tutto_insieme_ora_2)
  map.put("exp_content_tutto_insieme_ora_3", Res.string.exp_content_tutto_insieme_ora_3)
  map.put("exp_content_twt_ankh_imn_tutankhamon", Res.string.exp_content_twt_ankh_imn_tutankhamon)
  map.put("exp_content_un_attimo_1", Res.string.exp_content_un_attimo_1)
  map.put("exp_content_un_attimo_10", Res.string.exp_content_un_attimo_10)
  map.put("exp_content_un_attimo_11", Res.string.exp_content_un_attimo_11)
  map.put("exp_content_un_attimo_2", Res.string.exp_content_un_attimo_2)
  map.put("exp_content_un_attimo_3", Res.string.exp_content_un_attimo_3)
  map.put("exp_content_un_attimo_4", Res.string.exp_content_un_attimo_4)
  map.put("exp_content_un_attimo_5", Res.string.exp_content_un_attimo_5)
}
